export default __webpack_public_path__ + "016a9b2c79056404b66eb8a48a2041fb.svg";